// extracted by mini-css-extract-plugin
export default {"coll-info-wrap":"index_coll-info-wrap__psARh","more-operation":"index_more-operation__--DFq","more-operation-wrap":"index_more-operation-wrap__MwxfZ"};